import { render, staticRenderFns } from "./TopPostItems.vue?vue&type=template&id=62515b31&"
import script from "./TopPostItems.vue?vue&type=script&lang=js&"
export * from "./TopPostItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports